// @ngInject
function PaymentTypesApiService(ResourcesService) {

  var endpoint = 'paymenttypes';

  return {
    getPaymentTypes: ResourcesService.apiFactory.get(endpoint),
    getPaymentType: ResourcesService.apiFactory.get(endpoint),
    createPaymentType: ResourcesService.apiFactory.create(endpoint, 'PaymentType'),
    updatePaymentType: ResourcesService.apiFactory.update(endpoint, 'PaymentType'),
    deletePaymentType: ResourcesService.apiFactory.delete(endpoint, 'PaymentType')
  };

}

angular
  .module('paymenttypes.api', [])
  .factory('PaymentTypesApiService', PaymentTypesApiService);
